<template>
  <div id="contenedor-eliminar-obra">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Obra </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar la obra "{{obraEliminar.clave}}"? </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarObra"
          :disabled="enviandoFormulario"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import mixObras from './mixObras';

export default {
  name: 'ObrasEliminar',
  mixins: [mixObras],
  props: {
    obraEliminar: {
      type: Object,
      required: true,
    },
    filtros: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>
